// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2074":"5d4e5056","2855":"5b24b44f","4204":"f7669c59","5245":"ef25043c","5425":"77571bba"}[chunkId] + ".chunk.css";
};